<template>
    <div class="ci-wheel" :data-ready="uiReady" :data-detailed="isDetailed">
        <svg id="wheel" v-if="svgData" :class="colorScheme" ref="wheel" version="1.1"
             baseProfile="full"
             :viewBox="viewBox"
             xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"

        >


            <defs>

                <path id="citextpath" d="M35,50 A6,6 0 0 0 65,50"></path>

              <path id="ring2uppertextpath" d="M38,50 A6,6 0 0 1 62,50"></path>
              <path id="ring2lowertextpath" d="M35,50 A6,6 0 0 0 65,50"></path>


              <path id="ring2path" d="M35,50 a 15,15 0 1, 0 30,0 a 15,15 0 1, 0 -30,0"></path>

                <path id="middleuppertextpath" d="M26,50 A6,6 0 0 1 74,50"></path>
                <path id="middlelowertextpath" d="M24,50 A6,6 0 0 0 76,50"></path>

                <path v-for="(textPath, index) in svgData.textPaths" :key="index" :d="textPath" :id="index"></path>

                <filter id="dropshadow">
                    <feDropShadow dx="0.0" dy="0.0" stdDeviation="0.5"/>
                </filter>
              <filter id="drop-shadow-1" filterUnits="userSpaceOnUse">
                <feOffset dx="0" dy="0"/>
                <feGaussianBlur result="blur" stdDeviation="1"/>
                <feFlood flood-color="#020202" flood-opacity=".5"/>
                <feComposite in2="blur" operator="in"/>
                <feComposite in="SourceGraphic"/>
              </filter>


            </defs>

              <SegmentedRing v-for="(ringDetails, ringIndex) in ringData.rings" :key="ringDetails.id" :id="ringDetails.id" :onSegmentClick="onSegmentClick" :allow-hover="isDetailed" :selected-index="value.deck" :stroke-width="ringDetails.strokeWidth" :font-size="ringDetails.fontSize" :stroke-color="ringDetails.strokeColor" :inner-radius="ringDetails.innerRadius" :outer-radius="ringDetails.outerRadius" start-segment="0" :start-angle="ringDetails.startAngle" :origin="origin" :segment-fill="ringDetails.fillColor" :text-color="ringDetails.textColor" :ring-index="ringIndex" :sections="ringDetails.sections"/>
              <g id="PartnershipCircle">
                <g id="CircleGroup">
                  <circle id="CircleFill" cx="50" cy="50" r="22.5" style="fill:#fff;"/>
                </g>
                <g style="isolation:isolate;">
                  <text transform="translate(32.6 52.33) rotate(78.44)"
                        style="fill:#c00;  font-size:3.75px; font-weight:700; isolation:isolate;">
                    <tspan x="0" y="0">A</tspan>
                  </text>
                </g>
                <g style="isolation:isolate;">
                  <text transform="translate(33.41 55.74) rotate(67.25)"
                        style="fill:#c00;  font-size:3.75px; font-weight:700; isolation:isolate;">
                    <tspan x="0" y="0">C</tspan>
                  </text>
                </g>
                <g style="isolation:isolate;">
                  <text transform="translate(34.34 57.92) rotate(59.58)"
                        style="fill:#c00;  font-size:3.75px; font-weight:700; isolation:isolate;">
                    <tspan x="0" y="0">o</tspan>
                  </text>
                </g>
                <g style="isolation:isolate;">
                  <text transform="translate(35.57 59.92) rotate(53.81)"
                        style="fill:#c00;  font-size:3.75px; font-weight:700; isolation:isolate;">
                    <tspan x="0" y="0">l</tspan>
                  </text>
                </g>
                <g style="isolation:isolate;">
                  <text transform="translate(36.23 60.82) rotate(50.13)"
                        style="fill:#c00;  font-size:3.75px; font-weight:700; isolation:isolate;">
                    <tspan x="0" y="0">l</tspan>
                  </text>
                </g>
                <g style="isolation:isolate;">
                  <text transform="translate(36.98 61.74) rotate(44.75)"
                        style="fill:#c00;  font-size:3.75px; font-weight:700; isolation:isolate;">
                    <tspan x="0" y="0">a</tspan>
                  </text>
                </g>
                <g style="isolation:isolate;">
                  <text transform="translate(38.53 63.28) rotate(37.23)"
                        style="fill:#c00;  font-size:3.75px; font-weight:700; isolation:isolate;">
                    <tspan x="0" y="0">b</tspan>
                  </text>
                </g>
                <g style="isolation:isolate;">
                  <text transform="translate(40.52 64.77) rotate(29.21)"
                        style="fill:#c00;  font-size:3.75px; font-weight:700; isolation:isolate;">
                    <tspan x="0" y="0">o</tspan>
                  </text>
                </g>
                <g style="isolation:isolate;">
                  <text transform="translate(42.57 65.88) rotate(22.75)"
                        style="fill:#c00;  font-size:3.75px; font-weight:700; isolation:isolate;">
                    <tspan x="0" y="0">r</tspan>
                  </text>
                </g>
                <g style="isolation:isolate;">
                  <text transform="translate(43.99 66.48) rotate(16.74)"
                        style="fill:#c00;  font-size:3.75px; font-weight:700; isolation:isolate;">
                    <tspan x="0" y="0">a</tspan>
                  </text>
                </g>
                <g style="isolation:isolate;">
                  <text transform="translate(46.04 67.07) rotate(10.76)"
                        style="fill:#c00;  font-size:3.75px; font-weight:700; isolation:isolate;">
                    <tspan x="0" y="0">t</tspan>
                  </text>
                </g>
                <g style="isolation:isolate;">
                  <text transform="translate(47.5 67.34) rotate(6.43)"
                        style="fill:#c00;  font-size:3.75px; font-weight:700; isolation:isolate;">
                    <tspan x="0" y="0">i</tspan>
                  </text>
                </g>
                <g style="isolation:isolate;">
                  <text transform="translate(48.66 67.49) rotate(1.09)"
                        style="fill:#c00;  font-size:3.75px; font-weight:700; isolation:isolate;">
                    <tspan x="0" y="0">v</tspan>
                  </text>
                </g>
                <g style="isolation:isolate;">
                  <text transform="translate(50.8 67.52) rotate(-5.81)"
                        style="fill:#c00;  font-size:3.75px; font-weight:700; isolation:isolate;">
                    <tspan x="0" y="0">e</tspan>
                  </text>
                </g>
                <g style="isolation:isolate;">
                  <text transform="translate(53.79 67.13) rotate(-16.04)"
                        style="fill:#c00;  font-size:3.75px; font-weight:700; isolation:isolate;">
                    <tspan x="0" y="0">P</tspan>
                  </text>
                </g>
                <g style="isolation:isolate;">
                  <text transform="translate(55.99 66.48) rotate(-23.28)"
                        style="fill:#c00;  font-size:3.75px; font-weight:700; isolation:isolate;">
                    <tspan x="0" y="0">a</tspan>
                  </text>
                </g>
                <g style="isolation:isolate;">
                  <text transform="translate(57.98 65.61) rotate(-29.47)"
                        style="fill:#c00;  font-size:3.75px; font-weight:700; isolation:isolate;">
                    <tspan x="0" y="0">r</tspan>
                  </text>
                </g>
                <g style="isolation:isolate;">
                  <text transform="translate(59.38 64.79) rotate(-34.73)"
                        style="fill:#c00;  font-size:3.75px; font-weight:700; isolation:isolate;">
                    <tspan x="0" y="0">t</tspan>
                  </text>
                </g>
                <g style="isolation:isolate;">
                  <text transform="translate(60.68 63.91) rotate(-41.16)"
                        style="fill:#c00;  font-size:3.75px; font-weight:700; isolation:isolate;">
                    <tspan x="0" y="0">n</tspan>
                  </text>
                </g>
                <g style="isolation:isolate;">
                  <text transform="translate(62.48 62.32) rotate(-48.59)"
                        style="fill:#c00;  font-size:3.75px; font-weight:700; isolation:isolate;">
                    <tspan x="0" y="0">e</tspan>
                  </text>
                </g>
                <g style="isolation:isolate;">
                  <text transform="translate(63.88 60.7) rotate(-54.67)"
                        style="fill:#c00;  font-size:3.75px; font-weight:700; isolation:isolate;">
                    <tspan x="0" y="0">r</tspan>
                  </text>
                </g>
                <g style="isolation:isolate;">
                  <text transform="translate(64.79 59.4) rotate(-60.19)"
                        style="fill:#c00;  font-size:3.75px; font-weight:700; isolation:isolate;">
                    <tspan x="0" y="0">s</tspan>
                  </text>
                </g>
                <g style="isolation:isolate;">
                  <text transform="translate(65.69 57.83) rotate(-67.07)"
                        style="fill:#c00;  font-size:3.75px; font-weight:700; isolation:isolate;">
                    <tspan x="0" y="0">h</tspan>
                  </text>
                </g>
                <g style="isolation:isolate;">
                  <text transform="translate(66.57 55.65) rotate(-72.9)"
                        style="fill:#c00;  font-size:3.75px; font-weight:700; isolation:isolate;">
                    <tspan x="0" y="0">i</tspan>
                  </text>
                </g>
                <g style="isolation:isolate;">
                  <text transform="translate(66.95 54.5) rotate(-78.88)"
                        style="fill:#c00;  font-size:3.75px; font-weight:700; isolation:isolate;">
                    <tspan x="0" y="0">p</tspan>
                  </text>
                </g>
                <g id="Canon_Logo">
                  <path d="m46.85,34.52c-.31.45-.93.56-1.38.25s-.56-.93-.25-1.38c.3-.43.89-.55,1.34-.27l-.52.84.98-.57c-.16-.25-.39-.44-.67-.54-.45-.17-.95-.17-1.4,0-.22.08-.42.22-.57.41-.33.4-.33.99,0,1.39.15.18.35.32.57.41.37.14.77.16,1.16.07.3-.07.57-.23.78-.46,0,0-.04-.15-.04-.15Z"
                        style="fill:#c00;"/>
                  <path d="m51,33.15s-.1.01-.15.03l-.57.27c-.03-.17-.18-.3-.35-.3-.05,0-.1.01-.15.03l-.7.33h.49v1.61h.72v-1.44c0-.1.07-.18.17-.19.1,0,.18.07.19.17v1.46h.72v-1.61c0-.2-.16-.36-.36-.36h0Z"
                        style="fill:#c00;"/>
                  <path d="m55.5,33.15s-.1.01-.15.03l-.57.27c-.03-.17-.18-.3-.35-.3-.05,0-.1.01-.15.03l-.7.33h.49v1.61h.72v-1.44c0-.1.08-.18.18-.18s.18.08.18.18h0v1.44h.72v-1.61c0-.2-.16-.36-.36-.36h-.01Z"
                        style="fill:#c00;"/>
                  <path d="m52.67,33.15c-.56,0-1.02.46-1.01,1.02,0,.56.46,1.02,1.02,1.01.56,0,1.01-.45,1.01-1.01s-.45-1.02-1.01-1.02h-.01Zm.23,1.88c-.12.03-.24-.04-.27-.16l-.35-1.3c-.03-.12.04-.24.16-.27s.24.04.27.16h0l.35,1.3c.03.12-.04.24-.16.27h0Z"
                        style="fill:#c00;"/>
                  <path d="m48.41,34.53c0,.2-.16.36-.36.36s-.36-.16-.36-.36.16-.36.36-.36h0c.2,0,.36.16.36.36Zm.18.6h.72l-.41-1.54c-.07-.26-.3-.43-.57-.43-.07,0-.14.01-.2.04l-.89.32h.92l.16.58c-.16-.14-.36-.21-.57-.21-.16,0-.31.04-.44.11-.1.06-.19.14-.25.24-.11.18-.11.4,0,.58.06.1.15.18.25.24.41.22.92.11,1.2-.27l.09.34h-.01Z"
                        style="fill:#c00;"/>
                </g>
              </g>
              <g id="InnerCircle" class="inner-circle">
                <g id="InnerCircleRings">
                  <path d="m50,62.06c-6.65,0-12.06-5.41-12.06-12.06s5.41-12.06,12.06-12.06,12.06,5.41,12.06,12.06-5.41,12.06-12.06,12.06Zm0-24.08c-6.62,0-12.01,5.39-12.01,12.01s5.39,12.01,12.01,12.01,12.01-5.39,12.01-12.01-5.39-12.01-12.01-12.01Z"
                       fill="#000" opacity="0.1" />
                  <path d="m50,61.13c-6.14,0-11.14-5-11.14-11.14s5-11.14,11.14-11.14,11.14,5,11.14,11.14-5,11.14-11.14,11.14Zm0-22.18c-6.09,0-11.04,4.95-11.04,11.04s4.95,11.04,11.04,11.04,11.04-4.95,11.04-11.04-4.95-11.04-11.04-11.04Z"
                        fill="#000" opacity="0.2" />
                  <path d="m50,60.41c-5.74,0-10.41-4.67-10.41-10.41s4.67-10.41,10.41-10.41,10.41,4.67,10.41,10.41-4.67,10.41-10.41,10.41Zm0-20.72c-5.69,0-10.31,4.63-10.31,10.31s4.63,10.31,10.31,10.31,10.31-4.63,10.31-10.31-4.63-10.31-10.31-10.31Z"
                        fill="#000" opacity="0.4" />
                </g>
                <g id="InnerCircleText" @click="onCenterClick">
                  <circle cx="50" cy="49.99" r="9.61" fill="#fff" stroke="#888" stroke-width="0.2"/>

                  <g style="isolation:isolate;">
                    <text transform="translate(43.83 48.04)"
                          style=" font-size:4px; font-weight:700; isolation:isolate; letter-spacing:-.02em;">
                      <tspan x="0" y="0">P</tspan>
                    </text>
                    <text transform="translate(46.08 48.04)"
                          style=" font-size:4px; font-weight:700; isolation:isolate;">
                      <tspan x="0" y="0">a</tspan>
                    </text>
                    <text transform="translate(48.16 48.04)"
                          style=" font-size:4px; font-weight:700; isolation:isolate;">
                      <tspan x="0" y="0">tie</tspan>
                    </text>
                    <text transform="translate(52.84 48.04)"
                          style=" font-size:4px; font-weight:700; isolation:isolate;">
                      <tspan x="0" y="0">n</tspan>
                    </text>
                    <text transform="translate(55.16 48.04)"
                          style=" font-size:4px; font-weight:700; isolation:isolate;">
                      <tspan x="0" y="0">t</tspan>
                    </text>
                    <text transform="translate(43.92 51.54)"
                          style=" font-size:4px; font-weight:700; isolation:isolate; letter-spacing:-.02em;">
                      <tspan x="0" y="0">C</tspan>
                    </text>
                    <text transform="translate(46.22 51.54)"
                          style=" font-size:4px; font-weight:700; isolation:isolate;">
                      <tspan x="0" y="0">e</tspan>
                    </text>
                    <text transform="translate(48.33 51.54)"
                          style=" font-size:4px; font-weight:700; isolation:isolate;">
                      <tspan x="0" y="0">n</tspan>
                    </text>
                    <text transform="translate(50.65 51.54)"
                          style=" font-size:4px; font-weight:700; isolation:isolate;">
                      <tspan x="0" y="0">tric</tspan>
                    </text>
                  </g>
                  <g style="isolation:isolate;">
                    <text transform="translate(44.02 54.87)"
                          style=" font-size:2.3px; font-weight:700; isolation:isolate; letter-spacing:-.04em;">
                      <tspan x="0" y="0">V</tspan>
                    </text>
                    <text transform="translate(45.39 54.87)"
                          style=" font-size:2.3px; font-weight:700; isolation:isolate;">
                      <tspan x="0" y="0">alue based</tspan>
                    </text>
                  </g>
                </g>
              </g>
        </svg>

        <div class="callouts">
          <div class="callout callout-solutions">
            <div class="callout-dot"></div>
            <svg class="callout-line" xmlns="http://www.w3.org/2000/svg" width="200" height="100" viewBox="0 0 200 100">
              <path d="M1.5,98.5 L27,60 L150,60" stroke-width="0.25" stroke="#fff" fill="none" />
            </svg>
            <div class="callout-text">
              <h2 class="callout-title"><span>SOLUTION</span><br/><span>BASED</span></h2>
              <p class=""><span>Achieve more with</span><br /><span><b style="color:#cc0000">smarter spending</b></span></p>
            </div>
          </div>

          <div class="callout callout-patients">
            <div class="callout-dot"></div>
            <svg class="callout-line" xmlns="http://www.w3.org/2000/svg" width="200" height="100" viewBox="0 0 200 100">
              <path d="M198,2.5 L90,2.5" stroke-width="0.25" stroke="#fff" fill="none" />
            </svg>
            <div class="callout-text">
              <h2 class="callout-title"><span>PATIENT</span><br/><span>CENTRIC</span></h2>
              <p class=""><span>Improve patient care with</span><br /><span><b style="color:#cc0000">clinically proven solutions</b></span></p>
            </div>
          </div>

          <div class="callout callout-social">
            <div class="callout-dot"></div>
            <svg class="callout-line" xmlns="http://www.w3.org/2000/svg" width="200" height="100" viewBox="0 0 200 100">
              <path d="M2.5,2.5 L114,2.5" stroke-width="0.25" stroke="#fff" fill="none" />
            </svg>
            <div class="callout-text">
              <h2 class="callout-title"><span>SOCIALLY</span><br/><span>ACCOUNTABLE</span></h2>
              <p class=""><span>Build a <b style="color:#cc0000">healthier</b> and</span><br /><span><b style="color:#cc0000">more sustainable</b> society</span></p>
            </div>
          </div>



        </div>

    </div>
</template>

<script>



    //import RingOfSegments from "@/components/RingOfSegments";
    import ringData from "@/data/ringData";
    import SegmentedRing from "@/components/SegmentedRing";
    export default {
        name: "col-imaging-wheel-2023",
      components: {SegmentedRing},
      mounted: function(){
            this.svgData = this.generateSVGData();

            this.$nextTick(()=>{
                this.revealUI();
            })



        },

        watch: {
            value: function(val, oldVal){
                ////console.log('watch', val, oldVal);

                if(val && val.section == -1){

                    if(oldVal.section > -1){
                        //console.log("hide section", oldVal);
                        this.defocusSection(oldVal);
                    }

                }

                if(oldVal && val){

                    if(oldVal.category != val.category){

                        this.focusSelection(val, oldVal);

                    }else{
                        if(oldVal.section != val.section){
                            this.focusSelection(val, oldVal);
                        }
                    }
                }

            },

            isDetailed: function(val,oldVal){
              if(val !== oldVal){
                if(val){
                  this.revealDetails()
                }else{
                  this.hideDetails()
                }
              }
            },

            minimize: function(val, oldVal){
              //console.log("minimizing")
              if(val){
                this.contractWithoutEmit();
              }else{
                if(!val && oldVal){
                  this.isDetailed = true;
                  this.revealWithDetails()
                }
              }

            },

            showingContent: function(val, oldVal){
                if(!val && oldVal){
                  //console.log("hiding content")
                    if(this.isDetailed){
                      this.revealWithDetails()
                    }else{
                      this.reveal();
                    }

                }else{
                  //console.log("showing content")
                }
            }
        },

        props: {
            segments: {
                default: function(){
                    return [];
                }
            },



            value: {
                default: function(){
                    return null
                }
            },

            minimize: {
              default: function(){
                return false
              }
            },

            showingContent: {
                default: false
            }
        },
        data: function () {
            return {

                ringData,
                uiReady: false,
              isDetailed: false,

                colorScheme: "branded",


                selectedCategory: null,
                selectedSection: null, //{ category, section, slide }
                selectedSectionRef: null,
                selectedBubble: null,
                selectedPage: 0,

                svgRenderBox: {
                    width: 100,
                    height: 100
                },

                svgData: null,

                wheel: {


                    levels: [
                        { thickness: 24, gutter: 12, fill: "black", type: "slices", fontSize: 2.0, dx: 0, dy: 0 },
                        { thickness: 9, gutter: 0, fill: "black", type: "slices", fontSize: 2.4,  dx: 0, dy: 0  },
                        { thickness: 20, gutter: 0, size: 20, spacing: 15, fill: "white", type: "bubbles", fontSize: 1.4,  dx: 0, dy: 0  },

                    ],


                    strokeWidth: 1.0,
                    strokeColor: "white",
                    startAngle: 30,
                    circumference: 360
                },


            }
        },
        methods: {

            emitInteraction: function(){
                this.$emit("interaction");
            },

          revealDetails: function(){
            //let svgEl = document.getElementById("wheel");
            //console.log(svgEl)

            //console.log('reveal details')


              let callouts = document.querySelectorAll('.callout');


              if(callouts){


                callouts.forEach((callout, index)=>{
                  let calloutTexts = callout.querySelectorAll('span');
                  this.$tween.set(calloutTexts, {opacity:0})
                  let delay = (0.3 + (0.1 * index))
                  this.$tween.to(callout, 0.2, { opacity: 1.0,  delay: delay});
                  calloutTexts.forEach((text,textIndex)=>{
                    let textDelay = (delay+(0.1 * textIndex))
                    this.$tween.to(text, 0.2, { opacity: 1.0,  delay: textDelay});
                  })

                })
              }




          },

          hideDetails: function(){

              //console.log("hide details")
            //let svgEl = document.getElementById("wheel");
            let callouts = document.querySelectorAll('.callout');
            if(callouts){
              callouts.forEach((callout, index)=>{
                this.$tween.to(callout, 0.2, { opacity: 0,  delay:  (0.1 * index)});
              })
            }
          },

            revealUI: function(){

                let svgEl = document.getElementById("wheel");
                this.$tween.set(svgEl, { scale: 0, transformOrigin:"50% 50%" });

                // let level1 = svgEl.querySelector('.level1');
                // let level2 = svgEl.querySelector('.level2');
                // let level2Slices = level2.querySelectorAll('.slice');
                // let level3 = svgEl.querySelectorAll('.segment');
                //
                // this.$tween.set(svgEl, { scale: 0, transformOrigin:"50% 50%" });
                //
                // this.$tween.set(level1, { opacity: 0 });
                //
                // level2Slices.forEach((slice)=>{
                //     this.$tween.set(slice, { opacity: 0 });
                // })
                //
                // level3.forEach((segment)=>{
                //     this.$tween.set(segment, { opacity: 0});
                // })



                setTimeout(() => {
                    this.reveal();
                }, 10);

            },

            revealWithDetails: function(){

              //console.log('reveal with details')

              let svgEl = this.$refs.wheel;

              this.$tween.set(svgEl, { scale: 0, transformOrigin:"50% 50%" });

              this.$tween.to(svgEl, 0.3, { scale: 1.0, transformOrigin:"50% 50%", onComplete: ()=>{
                      this.revealDetails();
                }});

              this.$tween.to(svgEl, 1.0, { opacity: 1.5, onComplete: ()=>{
                  this.colorScheme = "branded";
                }})
            },


            reveal: function(){

             //('reveal without details')

                let svgEl = this.$refs.wheel;

                this.$tween.set(svgEl, { scale: 0, transformOrigin:"50% 50%" });

                this.$tween.to(svgEl, 0.3, { scale: 1.0, transformOrigin:"50% 50%", onComplete: ()=>{

                    }});

                this.$tween.to(svgEl, 1.0, { opacity: 1.5, onComplete: ()=>{
                      this.colorScheme = "branded";
                    }})


            },

            contract: function(){
                let svgEl = this.$refs.wheel;

                this.hideDetails();

                this.$tween.to(svgEl, 0.3, { scale: 0, transformOrigin:"50% 50%", delay: 0.2, onComplete: ()=>{
                        this.$emit("show-content");
                        //setTimeout(this.reveal, 500);
                        this.reveal();
                }});

                return;
            },

          contractWithoutEmit: function(){
            let svgEl = this.$refs.wheel;

            this.hideDetails();

            this.$tween.to(svgEl, 0.3, { scale: 0, transformOrigin:"50% 50%" });

          },


            onCenterClick: function(){

              //this.isDetailed = !this.isDetailed;



              if(!this.isDetailed){
                this.isDetailed = true;
              }else{
                this.contract();
                this.$emit("input", {
                  deck: "mainStory",
                  category: -1,
                  section: -1,
                  group: 0,
                  page: 0
                });

                this.emitInteraction();
              }



            },



            onCategoryClick: function(){

                //console.log("category click", posIndex);

                //this.defocusSection(this.value);
                //this.$emit('hide-content');
                //this.$emit("input", posIndex);

            },

            onSegmentClick: function(id){

                //this.setSelections(category, section);
              //console.log("onSegmentClick", id)

              if(this.isDetailed){
                let tgtPos = {
                  deck: id,
                  page: 0
                }


                if(!this.showingContent){
                  this.contract();
                }

                ////console.log("segment click", tgtPos);

                this.$emit("input", tgtPos);
                this.emitInteraction();
              }else{
                this.isDetailed = true;
              }



            },

            onBubbleClick: function(posIndex){

                //this.setSelections(posIndex.category, posIndex.section, posIndex.group);
                //this.$emit("bubble-click", posIndex);

                ////console.log("on bubble click", posIndex);

                if(!this.showingContent){

                    this.contract();
                    //this.$emit("show-content");

                }

                this.$emit("input", {...posIndex});
                this.emitInteraction();




            },

            setSelections: function(category, section, page){

                ////console.log("setSelections", category, section, page);

                if(category != undefined){

                    let tgtCategory = this.svgData.nodes[category];
                    if(this.selectedCategory != tgtCategory){
                        this.selectCategory(tgtCategory, category);
                        //return;
                    }

                    if (section != undefined){
                        let tgtSection = tgtCategory.sections[section];
                        ////console.log(tgtCategory, tgtSection);



                        if(this.selectedSection != tgtSection){
                            let sectionId = category + "_" + section;
                            this.selectSection(tgtSection, sectionId);
                        }
                    }
                }

                if(page != undefined){
                    this.selectPage(page);
                }

            },

            selectCategory: function(categoryInfo){
                ////console.log("select category", categoryInfo);

                this.defocusCategory(this.selectedCategory);
               categoryInfo.active = true;
               this.selectedCategory = categoryInfo;
            },

            focusSelection: function(newPos, oldPos){
                ////console.log(sectionId);
                this.defocusSection(oldPos);

                if(newPos && newPos.section > -1){
                    let sectionId = newPos.category + "_"+newPos.section;
                    ////console.log("focus", sectionId);
                        this.selectedSectionRef = this.$refs[sectionId][0];
                    //let segment = this.selectedSectionRef.querySelector(".segment");
                    let bubbles = this.selectedSectionRef.querySelectorAll(".bubbles .bubble");
                    let circles = this.selectedSectionRef.querySelectorAll(".bubbles .bubble .circle");
                    bubbles.forEach((bubble, index) => {
                        let circle = circles[index];
                        let delay = 0.1 * index;
                        bubble.dataset.active = false;
                        this.$tween.set(bubble, { opacity: 0, display: "inline" });
                        this.$tween.set(circle, { scale: 0.0, transformOrigin:"50% 50%" });
                        this.$tween.to(bubble, 0.3, { opacity: 1.0, delay: delay });
                        this.$tween.to(circle, 0.3, { scale: 1.0, delay: delay, transformOrigin:"50% 50%" });

                    })
                    ////console.log(this.selectedSectionRef, bubbles);
                    //sectionInfo.active = true;
                }



            },

            selectSection: function(sectionInfo, sectionId){
                ////console.log(sectionId);
                this.defocusSection(this.selectedSection);

                this.selectedSection = sectionInfo;

                this.selectedSectionRef = this.$refs[sectionId][0];
                //let segment = this.selectedSectionRef.querySelector(".segment");
                let bubbles = this.selectedSectionRef.querySelectorAll(".bubbles .bubble");
                let circles = this.selectedSectionRef.querySelectorAll(".bubbles .bubble .circle");
                bubbles.forEach((bubble, index) => {
                    let circle = circles[index];
                    let delay = 0.1 * index;
                    bubble.dataset.active = false;
                    this.$tween.set(bubble, { opacity: 0, display: "inline" });
                    this.$tween.set(circle, { scale: 0.0, transformOrigin:"50% 50%" });
                    this.$tween.to(bubble, 0.3, { opacity: 1.0, delay: delay });
                    this.$tween.to(circle, 0.3, { scale: 1.0, delay: delay, transformOrigin:"50% 50%" });

                })
                ////console.log(this.selectedSectionRef, bubbles);
                sectionInfo.active = true;

            },

            selectPage: function(page){
                ////console.log("selectPage", this.selectedSectionRef);
                var bubbles = this.selectedSectionRef.querySelectorAll(".bubbles .bubble");
                bubbles.forEach((bubble, index) => {
                    bubble.dataset.active = (index == page);
                })
            },

            defocusCategory: function(categoryInfo){
                if(categoryInfo){
                    categoryInfo.active = false;
                    this.defocusSection(this.selectedSection);
                    this.selectedSection = null;
                    // let bubbles = this.selectedSectionRef.querySelectorAll(".bubbles .bubble");
                    // bubbles.forEach((bubble) => {
                    //
                    //     this.$tween.to(bubble, 0.3, { opacity: 0.0, onComplete: (b)=>{
                    //             //console.log("completed", b);
                    //             b.display = "none";
                    //         }, onCompleteParams: [bubble]});
                    // })
                }

            },

            defocusSection: function(posIndex){

                ////console.log("defocus", posIndex);
                if(posIndex && posIndex.category > -1 && posIndex.section > -1){
                    let sectionId = posIndex.category + "_"+posIndex.section;
                    ////console.log("defocus", sectionId);
                    let bubbles = this.$refs[sectionId][0].querySelectorAll(".bubbles .bubble");
                    bubbles.forEach((bubble) => {

                        this.$tween.to(bubble, 0.3, { opacity: 0.0, onComplete: (b)=>{
                                ////console.log("completed", b);
                                this.$tween.set(b, { display: 'none'});
                            }, onCompleteParams: [bubble]});
                    })
                }

            },


            arcSlice: function(origin, rInner, rOuter, startAngle, sweep){

                ////console.log(origin, rInner, rOuter, startAngle, sweep);

                //var d = "M275,175 v-100 a100,100 0 0,1 100,100 z";
                var A1, A2, A3, A4;

                A1 = this.arcPos(origin, rInner, startAngle);
                A2 = this.arcPos(origin, rOuter, startAngle);
                A3 = this.arcPos(origin, rOuter, startAngle + sweep);
                A4 = this.arcPos(origin, rInner, startAngle + sweep);

                let rotation = 0;
                let arcFlag = 0;



                var d = "M"+A1.x + ","+A1.y;
                d += " L"+A2.x + ","+A2.y;
                d += `A${rOuter},${rOuter} ${rotation} ${arcFlag},1 ${A3.x},${A3.y}`;
                d += " L"+A4.x + ","+A4.y;
                d += `A${rInner},${rInner} ${rotation} ${arcFlag},0 ${A1.x},${A1.y}`;
                d += " Z";
                ////console.log(d);
                return d;

            },


          //used to create circle from path (in cases of a single slice)
          circlePath: function(origin, rInner, rOuter, startAngle, sweep){

            ////console.log(origin, rInner, rOuter, startAngle, sweep);

            //var d = "M275,175 v-100 a100,100 0 0,1 100,100 z";
            var A1, A2, A3, A4;

            A1 = this.arcPos(origin, rInner, startAngle);
            A2 = this.arcPos(origin, rOuter, startAngle);
            A3 = this.arcPos(origin, rOuter, startAngle + sweep);
            A4 = this.arcPos(origin, rInner, startAngle + sweep);

            let rotation = 0;
            let arcFlag = 0;



            var d = "M"+A1.x + ","+A1.y;
            d += " L"+A2.x + ","+A2.y;
            d += `A${rOuter},${rOuter} ${rotation} ${arcFlag},1 ${A3.x},${A3.y}`;
            d += " L"+A4.x + ","+A4.y;
            d += `A${rInner},${rInner} ${rotation} ${arcFlag},0 ${A1.x},${A1.y}`;
            d += " Z";
            ////console.log(d);
            return d;

          },

            arc: function(origin, rInner, rOuter, startAngle, sweep, flip){

                ////console.log(origin, rInner, rOuter, startAngle, sweep);

                let baseline = rInner + (rOuter - rInner)/2;

                //var d = "M275,175 v-100 a100,100 0 0,1 100,100 z";
                var A1, A2, A3, A4;

                A1 = this.arcPos(origin, baseline, startAngle);

                A2 = this.arcPos(origin, baseline, startAngle + sweep);

                let rotation = 0;
                let arcFlag = 0;
                let sweepFlag = 1;

                if(flip){
                    A3 = A2;
                    A4 = A1;
                    A1 = A3;
                    A2 = A4;


                    //arcFlag = 1;
                    sweepFlag = 0;
                }






                var d = "M"+A1.x + ","+A1.y;
                d += `A${baseline},${baseline} ${rotation} ${arcFlag},${sweepFlag} ${A2.x},${A2.y}`;
                return d;

            },

            spokeBubble: function(origin, innerRadius, outerRadius, startAngle, lineAngle, bubbleDiameter, ){

                let bubbleRadius = bubbleDiameter/2;
                let bubbleOrbit = outerRadius - bubbleRadius;
                //let lineLength = bubbleOrbit - innerRadius;

                let A1 = this.arcPos(origin, innerRadius, startAngle);


                let A2 = this.arcPos(origin, bubbleOrbit, startAngle - lineAngle);
                var d = "M"+A1.x + ","+A1.y;
                d += "L"+A2.x + ","+A2.y;

                return {
                    d: d,
                    a: A1,
                    b: A2,
                    r: bubbleRadius
                };
            },

            arcPos: function(origin, radius, angle) {
                var radians = (Math.PI / 180) * angle;
                var posX = radius * Math.cos(radians) + origin.x;
                var posY = radius * Math.sin(radians) + origin.y;
                return {
                    x: posX,
                    y: posY
                }
            },

            getTotalWeight: function(segments){

              //used to calculate relative slize size weights (size 2.0 is 2x the size of other slices)


              let totalWeight = segments.reduce((total, category) =>{


                let categorySize = category.segments.reduce((subtotal,segment) => {
                  let segmentSize = segment.size?segment.size:1;
                  return (subtotal + segmentSize);
                },0)
                return (total + categorySize)
              },0)

              return totalWeight;
            },



            generateSVGData: function(){




                let origin = this.origin;
                let circumference = this.wheel.circumference; //degrees
                let startAngle = this.wheel.startAngle;

                var innerRadius = this.wheel.levels[0].gutter;
                var outerRadius = innerRadius + this.wheel.levels[0].thickness;

                var textPaths = {};

                let totalWeight = this.getTotalWeight(this.segments);
                //console.log(totalWeight);


                var nodeData = this.segments.map((category, catIndex) => {

                    let levelInfo = this.wheel.levels[0];
                    let sliceDegreeSpan = circumference / this.segments.length;
                    let normalizedDegreeSpan = circumference / totalWeight; //weighted span by size


                    let segmentStart = startAngle + (sliceDegreeSpan * catIndex);
                    //console.log(catIndex, sliceDegreeSpan, normalizedDegreeSpan, segmentStart);

                    //textPaths["c"+catIndex] = this.arc(origin, innerRadius, outerRadius, segmentStart, sliceDegreeSpan); //for curved text
                    let textPosBias = 0.45; //distance between innner and outer radius
                    let textPos= this.arcPos(origin, (innerRadius + (outerRadius - innerRadius) * textPosBias),(segmentStart + (sliceDegreeSpan/2)));
                    let cumulativeSpanDegrees = 0;

                    return {
                        d: (this.segments.length > 1)?this.arcSlice(origin, innerRadius, outerRadius, segmentStart, sliceDegreeSpan):this.circlePath(origin, innerRadius, outerRadius, segmentStart, sliceDegreeSpan),
                        active: false,
                        textPath: "c"+catIndex,
                        textPos: textPos,
                        class: "level1",
                        label: category.label,
                        fill: levelInfo.fill,
                        fontSize: levelInfo.fontSize,
                        textDx: levelInfo.dx,
                        textDy: levelInfo.dy,

                        sections: category.segments.map((subcategory, subcatIndex) => {


                            let subcatLevelInfo = this.wheel.levels[1];
                            let bubbleLevelInfo = this.wheel.levels[2];
                            //let subsliceDegreeSpan = sliceDegreeSpan / category.segments.length;
                            let spanWeight = subcategory.size?subcategory.size:1;
                            let weightedSubsliceDegreeSpan = spanWeight * normalizedDegreeSpan;

                            //console.log(subsliceDegreeSpan, spanWeight, weightedSubsliceDegreeSpan);
                            //let subsegmentStart = segmentStart + (subsliceDegreeSpan * subcatIndex);
                            let subsegmentStart = segmentStart + cumulativeSpanDegrees;
                            cumulativeSpanDegrees += weightedSubsliceDegreeSpan;
                            let level1InnerRadius = outerRadius + subcatLevelInfo.gutter;
                            let level1OuterRadius = level1InnerRadius + subcatLevelInfo.thickness;
                            let level2InnerRadius = level1InnerRadius + subcatLevelInfo.thickness + bubbleLevelInfo.gutter;
                            //let level2SpokeOriginAngle = subsegmentStart + (subsliceDegreeSpan / 2);
                            let level2SpokeOriginAngle = subsegmentStart + (weightedSubsliceDegreeSpan / 2);
                            let level2SpokeDegreeSpan = bubbleLevelInfo.spacing;
                            let level2BubbleRadius = bubbleLevelInfo.size / 2;

                            ////console.log(level1OuterRadius, level2InnerRadius);

                            //textPaths["c"+catIndex+"-s"+subcatIndex] = this.arc(origin, level1InnerRadius, level1OuterRadius, subsegmentStart, subsliceDegreeSpan, subcategory.labelFlip)
                          textPaths["c"+catIndex+"-s"+subcatIndex] = this.arc(origin, level1InnerRadius, level1OuterRadius, subsegmentStart, weightedSubsliceDegreeSpan, subcategory.labelFlip)

                            return {
                                //d: this.arcSlice(origin, level1InnerRadius, level1OuterRadius, subsegmentStart, subsliceDegreeSpan),
                                d: this.arcSlice(origin, level1InnerRadius, level1OuterRadius, subsegmentStart, weightedSubsliceDegreeSpan),
                                active: false,
                                textPath: "c"+catIndex+"-s"+subcatIndex,
                                class: "level2",
                                label: subcategory.label,
                                fill: subcatLevelInfo.fill,
                                fontSize: subcatLevelInfo.fontSize,
                                textDx: subcatLevelInfo.dx,
                                textDy: subcatLevelInfo.dy,


                                sections: subcategory.segments.map((bubble, bubbleIndex) => {



                                    let lineAngleOffset = (level2SpokeDegreeSpan * (subcategory.segments.length - 1))/ 2;
                                    let lineAngle = (level2SpokeDegreeSpan * bubbleIndex) - lineAngleOffset;
                                    ////console.log(subcategory.label, bubbleIndex,"line angle", lineAngle);
                                    let spokeData = this.spokeBubble(origin, level2InnerRadius, level2InnerRadius + bubbleLevelInfo.thickness, level2SpokeOriginAngle, lineAngle, level2BubbleRadius );
                                    let bubbleTextPos = spokeData.b;


                                    return {
                                        d: spokeData.d,
                                        a: spokeData.a,
                                        b: spokeData.b,
                                        r: spokeData.r,
                                        active: false,
                                        textPos: bubbleTextPos,
                                        fontSize: bubbleLevelInfo.fontSize,
                                        textDx: bubbleLevelInfo.dx,
                                        textDy: bubbleLevelInfo.dy,
                                        label: bubble.label.split("/n").map((labelText, index, labels) => {

                                            let dy = bubbleLevelInfo.fontSize / 2;
                                            let parentDy = 0;

                                            if(labels.length > 1){

                                                parentDy = -bubbleLevelInfo.fontSize * 0.75;

                                                if( index ){
                                                    dy += bubbleLevelInfo.fontSize * 1.3;
                                                }
                                            }


                                            return {
                                                text: labelText,
                                                dy: dy,
                                                parentYOffset: parentDy
                                            }
                                        })

                                    }
                                })
                            }


                        })
                    }


                })

                return {
                    nodes: nodeData,
                    textPaths: textPaths
                }


            }




        },
        computed: {





            origin: function(){
                return {
                    x: this.svgRenderBox.width / 2,
                    y: this.svgRenderBox.height / 2
                }
            },

            viewBox: function(){
                return "0 0 "+ this.svgRenderBox.width + " "+this.svgRenderBox.height;
            },


        }
    }
</script>

<style scoped>




    .ci-wheel {






    }

    .wireframe {

        --level0-fill: var(--brand-transparent);
        --level0-stroke: var(--wireframe);
        --level0-text: var(--wireframe);
        --level0-text-brand: var(--brand-red);

        --level1-fill: var(--brand-black);
        --level1-stroke: var(--wireframe);
        --level1-text: var(--wireframe);
        --level1-text-brand: var(--wireframe);

        --level2-fill: var(--brand-transparent);
        --level2-stroke: var(--wireframe);
        --level2-text: var(--wireframe);

        --level3-fill: var(--brand-transparent);
        --level3-stroke: var(--wireframe);
        --level3-text: var(--wireframe);

        --level3-fill-select: var(--wireframe);
        --level3-stroke-select: var(--wireframe);
        --level3-text-select: var(--wireframe-bright);

        --level4-fill: var(--brand-black);
        --level4-stroke: var(--wireframe);
        --level4-text: var(--wireframe);

        --level4-fill-select: var(--wireframe);
        --level4-stroke-select: var(--wireframe);
        --level4-text-select: var(--wireframe-bright);

    }

    .branded {
        --level0-fill: var(--brand-white);
        --level0-stroke: var(--brand-black);
        --level0-text: var(--brand-black);
        --level0-text-brand: var(--brand-red);

        --level1-fill: var(--brand-white);
        --level1-stroke: var(--brand-white);
        --level1-text: var(--brand-black);
        --level1-text-brand: var(--brand-red);

        --level2-fill: var(--brand-red);
        --level2-stroke: var(--brand-black);
        --level2-text: var(--brand-white);

        --level3-fill: var(--brand-gray);
        --level3-stroke: var(--brand-black);
        --level3-text: var(--brand-white);

        --level3-fill-select: var(--brand-gray-light);
        --level3-stroke-select: var(--brand-black);
        --level3-text-select: var(--brand-black);

        --level4-fill: var(--brand-gray-light);
        --level4-stroke: var(--brand-gray-light);
        --level4-text: var(--brand-black);

        --level4-fill-select: var(--brand-red);
        --level4-stroke-select: var(--brand-white);
        --level4-text-select: var(--brand-white);

    }



    #wheel {


    }

    #ci-icon {



    }

    #wheel path, #wheel circle, #wheel line {

    }

    #wheel line, #wheel text {
        pointer-events: none;
        user-select: none;
    }




    .slice {



        cursor: pointer;
    }

    .middle-circle {
      fill: var(--level2-fill);
    }

    .middle-text {
      fill: white;
    }

    .slice path {
        stroke: var(--level2-stroke);
        transition: stroke, fill 0.3s
    }

    .slice text {
        pointer-events: none;
        user-select: none;
        fill: var(--level2-text);

        letter-spacing: 0.05em;
    }

    .slice .slice-path  {

        fill: var(--level2-fill);


    }

    .slice .segments .segment path {
        fill: var(--level3-fill);
    }

    .slice .segments .segment:hover path {
      fill: #777;
    }

    .slice .segments .segment text {
      fill: #fff;
    }


    .slice .segments .segment:hover text {

    }






    .slice[data-active="true"] .segments .segment[data-active="true"] path {
        fill: #888;
    }

    .bubbles .bubble {

        display: none;
        opacity: 0;
    }


    .segment .bubbles .bubble circle, .segment .bubbles .bubble line {
        fill: var(--level4-fill);
        stroke: var(--level4-stroke);

    }

    .segment .bubbles .bubble text {

        fill: var(--level4-text);

    }



    .segment[data-active="true"] .bubbles .bubble[data-active=true] circle {

        fill: var(--level4-fill-select);
        stroke: var(--level4-stroke-select);

    }

    .segment[data-active="true"] .bubbles .bubble[data-active=true] text {

        fill: var(--level4-text-select);

    }


    @keyframes glowPulsate {
      0% {
        transform: scale(100%);
      }

      50% {
        transform: scale(105%);
      }

      100% {
        transform: scale(100%);
      }

    }

    @keyframes redPulsate {
      0% {
        transform: scale(100%);
        fill: black;
      }

      50% {
        transform: scale(105%);
        fill: #cc0000;
      }

      100% {
        transform: scale(100%);
        fill: black;
      }

    }

    @keyframes redStrokePulsate {
      0% {
        transform: scale(100%);
        stroke: black;
      }

      50% {
        transform: scale(105%);
        stroke: #cc0000;
      }

      100% {
        transform: scale(100%);
        stroke: black;
      }

    }

    #inner-circle circle {
        stroke: var(--level0-stroke);
        fill: var(--level0-fill);
    }

    #inner-circle text {
        fill: var(--level1-text-brand);
    }

    #inner-circle text.canon-medical {
        fill: var(--level1-text);
    }

    #madeforlife {
        fill: var(--level1-text);

      transform: scale(1.5);
    }

    #canon {
        transform: translateY(2.4%) scale(0.8);
    }

    #inner-circle circle.stroke-circle {
      stroke: #888;
    }

    #InnerCircleRings {
      transform-origin: center;

    }

    #InnerCircleText {
      transform-origin: center;
      transition: 0.3s all;
    }

    #InnerCircle #InnerCircleText circle {
      transform-origin: center;
      transition: 0.3s all;
    }

    #InnerCircle #InnerCircleText circle {
      transform-origin: center;
      stroke: #cc0000;
    }

    #InnerCircle:hover #InnerCircleText circle {
        stroke: #CC0000;
        stroke-width: 0.3;
    }


    #InnerCircle #InnerCircleRings path {
      transform-origin: center;
      animation-iteration-count: infinite;
      animation-name: redPulsate;
      animation-duration: 1s;
    }

    #InnerCircle:hover #InnerCircleRings path {
      fill: red;
    }

    .callouts {
      pointer-events: none;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    .callout {
      position: absolute;
    }

    .callout-dot {
      width: 1em;
      height: 1em;
      border-radius: 100%;
      border: 1px solid white;
      position: absolute;

    }

    .callout-dot:after {
      content: "";
      position: absolute;
      top: 0.25em;
      left: 0.25em;
      width: 0.5em;
      height: 0.5em;
      border-radius: 100%;
      background-color: white;
    }

    .callout-text {
      position: absolute;
      color:white;
    }

    .callout-text p {
      line-height: 1.3em;
    }

    .callout-solutions {
      height: 50%;
      position: relative;
      bottom: 20%;
      left: 63.5%;
    }

    .callout-solutions .callout-dot {
        bottom: 0;
      left: 0;
    }

    .callout-solutions .callout-line {
      width: 100%;
      height: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
    }

    .callout-solutions .callout-text {

      right: 25%;
      width: 20%;
      top: 60%;
      margin-top: 1em;


    }



    .callout-patients {
      height: 50%;
      position: relative;
      top: 0%;
      right: 80%;
    }

    .callout-patients .callout-dot {
      right: 0;
      top: 0;
    }

    .callout-patients .callout-line {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      right: 0;
    }

    .callout-patients .callout-text {

      left: 48%;
      width:25%;
      top: 0%;
      margin-top: 1.5em;


    }

    .callout-social {
      height: 50%;
      position: relative;
      bottom: 34%;
      left: 81.5%;
    }

    .callout-social .callout-dot {
      top: 0;
      left: 0;
    }

    .callout-social .callout-line {
      width: 100%;
      height: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
    }

    .callout-social .callout-text {

      right: 43%;
      width: 25%;
      top: 3.5%;
      margin-top: 1em;


    }

    #ring-solutions {
      transition: 0.5s all;
      transform-origin: center;
      transform: rotate(-90deg)

    }

    #ring-solution-based {
      transition: 0.5s all;
      transform-origin: center;
    }

    #ring-patient-centric {
      transition: 0.5s all;
      transform-origin: center;
      transform: scale(0.85) rotate(90deg);
    }

    #ring-sustainable-future {
      transition: 0.5s all;
      transform-origin: center;
      transform: scale(0.85);
    }

    .ci-wheel[data-detailed="true"] #ring-solution-based {
      transform: scale(0.75);
    }

    .ci-wheel[data-detailed="true"] #ring-solutions {
      transform: rotate(0deg);
    }

    .ci-wheel[data-detailed="true"] #ring-patient-centric {
      transform: scale(1.0) rotate(0deg);
    }

    .ci-wheel[data-detailed="true"] #ring-patient-centric {
      transform: scale(1.0);
    }

    .ci-wheel[data-detailed="true"] #ring-sustainable-future {
      transform: scale(1.0);
    }

    .callout {
      opacity: 0;
    }

    .ci-wheel #wheel #InnerCircle {
      transform-origin: center;
      transition: 0.3s transform;
    }

    .ci-wheel #wheel:hover #InnerCircle {
      transform: scale(105%);
    }

    svg text {
      pointer-events: none;
    }



    /*#wheel {*/
    /*  filter: drop-shadow(0px 0px 5vw #cc0000);*/
    /*}*/

















</style>